import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';
import { AppContext } from '../../AppProvider';

export class Services extends Component {
  static propTypes = {
    shipment: PropTypes.shape({
      requestedServices: PropTypes.array.isRequired
    })
  };

  render() {
    const { classes, t, shipment } = this.props;
    const {
      accessorialServices: serviceTypes
    } = this.context.globalProps.referenceData;

    return (
      <Fragment>
        <div className={classes.titleRootWrapper}>
          <h2 className={classes.headline7}>{t('Services')}</h2>
        </div>
        <p className={classes.body2Light}>
          {shipment.requestedServices
            .map(
              requestedService =>
                (
                  serviceTypes.find(
                    serviceType => serviceType.value === requestedService
                  ) || { title: '' }
                ).title
            )
            .join(', ')}
        </p>
      </Fragment>
    );
  }
}

Services.contextType = AppContext;
const ServicesWithTranslations = withNamespaces()(Services);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, SpacingStyles)
)(ServicesWithTranslations);
